import styled from "styled-components";
import { OVERLAY_Z_INDEX } from "../../../../../utils";
import { FlexColumn } from "../../../../Common/Styles";

export const DropdownWrapper = styled(FlexColumn)`
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.spacing["spacing-2"].value}rem);
  right: 0;
  width: 336px;
  z-index: ${OVERLAY_Z_INDEX};
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-overlay"].value};
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  outline: none;
`;

export const Wrapper = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
`;

export const AccountManageContainer = styled(Wrapper)`
  box-shadow: 1px 1px 7px 0px #d2d7db;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-primary-subtle"].value};
`;

export const Container = styled.div`
  position: relative;
`;

export const UserContainer = styled(Container)`
  max-width: 304px;
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;
